import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
// eslint-disable-next-line import/extensions
import { useTimeOnPage } from '@3plearning/mx-teacher-analytics/react';
import useAnalyticsClient from '../client/use-analytics-client';
import useAnalyticsIdentity from '../identity/use-analytics-identity';

export default function AnalyticsListener() {
  const client = useAnalyticsClient();

  useAnalyticsIdentity();
  usePageTracking(client);

  if (!client) return null;

  return <TimeOnPageTracker client={client} />;
}

function usePageTracking(client) {
  const trackedRef = useRef(false);

  useEffect(() => {
    if (!client || trackedRef.current) return;

    trackedRef.current = true;
    client.track('page.view', {});
    client.trackSession(window.location.pathname);
  }, [client]);
}

function TimeOnPageTracker({ client }) {
  useTimeOnPage(client);
  return null;
}

TimeOnPageTracker.propTypes = {
  client: PropTypes.object.isRequired
};
